<template>
  <section class="card dashboard-welcome">
    <div class="card-body">
      <div class="welcome-header">
        <div class="welcome-icon bg-soft-info text-info" aria-hidden="true">
          <i class="mdi mdi-account-circle-outline"></i>
        </div>
        <div class="welcome-identity">
          <h3>
            {{
              name
                ? $t("label.dashboardWelcomeName", [name])
                : $t("label.dashboardWelcome")
            }}
          </h3>
          <p v-if="email" class="text-muted mb-0 account-email">{{ email }}</p>
        </div>
      </div>
      <template v-if="shortcuts.length">
        <h5 class="mt-4">{{ $t("label.dashboardQuickAccess") }}</h5>
        <p class="text-muted">{{ $t("label.dashboardQuickAccessHint") }}</p>
        <div class="row">
          <div
            v-for="shortcut in shortcuts"
            :key="shortcut.permission"
            class="col-12 col-md-6 col-xl-4 mb-3"
          >
            <router-link :to="{ name: shortcut.route, query: shortcut.query }" class="shortcut-link">
              <i
                :class="[
                  'mdi',
                  shortcut.icon,
                  'text-info',
                  'font-size-24',
                  'mr-3',
                ]"
                aria-hidden="true"
              ></i>
              <span class="font-weight-semibold">{{ $t(shortcut.label) }}</span>
              <i
                class="mdi mdi-chevron-right ml-auto text-muted"
                aria-hidden="true"
              ></i>
            </router-link>
          </div>
        </div>
      </template>
      <div v-else class="welcome-message">
        <p class="font-size-16 mb-2">{{ $t("label.dashboardNoModules") }}</p>
        <p class="text-muted mb-0">
          {{ $t("label.dashboardContactAdministrator") }}
        </p>
      </div>
      <b-button
        variant="info"
        class="profile-button"
        @click="profileVisible = true"
      >
        <i class="mdi mdi-account-outline mr-1" aria-hidden="true"></i
        >{{ $t("label.dashboardViewProfile") }}
      </b-button>
    </div>
    <b-modal
      v-model="profileVisible"
      :title="$t('module.profile')"
      hide-footer
      centered
    >
      <dl class="mb-0">
        <dt>{{ $t("label.name") }}</dt>
        <dd>{{ name || "—" }}</dd>
        <dt>{{ $t("label.email") }}</dt>
        <dd class="account-email">{{ email || "—" }}</dd>
      </dl>
    </b-modal>
  </section>
</template>
<script>
export default {
  name: "DashboardFallback",
  props: {
    name: { type: String, default: "" },
    email: { type: String, default: "" },
    shortcuts: { type: Array, default: () => [] },
  },
  data() {
    return { profileVisible: false };
  },
};
</script>
<style scoped>
.dashboard-welcome .card-body {
  padding: clamp(24px, 4vw, 48px);
}
.welcome-header {
  display: flex;
  align-items: center;
  gap: 20px;
}
.welcome-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  font-size: 42px;
  flex-shrink: 0;
}
.welcome-identity {
  min-width: 0;
}
.welcome-identity h3 {
  line-height: 1.4;
}
.account-email {
  overflow-wrap: anywhere;
}
.welcome-message {
  margin: 32px 0 24px;
  max-width: 640px;
}
.shortcut-link {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 20px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  color: #343a40;
  transition: border-color 0.15s;
}
.shortcut-link:hover,
.shortcut-link:focus-visible {
  border-color: #50a5f1;
}
@media (max-width: 575px) {
  .welcome-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .profile-button {
    width: 100%;
  }
}
</style>
